"use stric";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";

const CarsService = {
  getCars: function (options) {
    const body = JSON.parse(JSON.stringify(options));
    delete body._currentWintrerCompanies;

    return api.post("units", body, WithToken.headersToken({}, configuration.cookieName));
  },
  setBookmark: function (id) {
    return api.post("Units/" + id + "/Bookmarks", {}, WithToken.headersToken({}, configuration.cookieName));
  },
  deleteBookmark: function (id) {
    return api.delete("Units/" + id + "/Bookmarks", WithToken.headersToken({}, configuration.cookieName));
  },
  getCarShortInfo: function (id) {
    return api.get("units/" + id + "/information", {}, WithToken.headersToken({}, configuration.cookieName));
  },
  updateUnitSupport: function (id, options) {
    return api.put("units/" + id + "/SupportServices", {}, WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  unitShared: function (id, options) {
    return api.post("Units/" + id + "/Shareds", {}, WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  unitUnShared: function (id, options) {
    return api.delete("Units/" + id + "/Shareds", WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  getUnitSettings: function (id) {
    return api.get("units/" + id + "/Settings", WithToken.headersToken({}, configuration.cookieName));
  },
  updateUnitSetting: function (id, options) {
    return api.put("units/" + id + "/Settings", options, WithToken.headersToken({}, configuration.cookieName));
  },
  updateUnitInformation: function (id, options) {
    return api.post("units/" + id + "/Information", options, WithToken.headersToken({}, configuration.cookieName));
  },
};

export default CarsService;
